import React, { useEffect, useState } from "react";
import ConsultantLayout from "../commonlayouts/consultantlayout.js";
import Axios from "axios";
import { GetCandidateById, GetJobRoles, GetCourseInfo } from "../apiconstants/constants.js";
import { Link, useLocation } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-bootstrap/Modal';
import LoadingSpinner from "../helpers/loadingspinner.js";
import { useCountry } from "../contexts/countrycodecontext.js";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ViewInternalCandidateDetailsByCandidateGUid = () => {
    let query = useQuery();
    const guid = query.get("candidateID");
    let Guid="";
    const {selectedCountry} = useCountry();
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [jobRoles, setJobRoles] = useState([]);
    const [qualifications, setQualifications] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({ title: "", url: "" });

    const fetchJobRoles = async () => {
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        try {
            const response = await Axios.get(getApiUrl);
            setJobRoles(response.data);
        } catch (error) {
            console.error("Error fetching job roles", error);
        }
    };

    const fetchQualifications = async () => {
        const getApiUrl = GetCourseInfo.APIURL;
        try {
            const response = await Axios.get(getApiUrl);
            setQualifications(response.data);
        } catch (error) {
            console.error("Error fetching qualifications", error);
        }
    };

    const GetCandidateDetails = async () => {
        const GetapiUrl = GetCandidateById.APIURL;
        const params = { guid: guid };

        try {
            const result = await Axios.post(GetapiUrl, params);
            setCandidateDetails(result.data);
        } catch (error) {
            console.error("Error fetching candidate details:", error);
        }
    };

    

const handleDownload = (url) => {
  const fileExtension = url.split('.').pop().toLowerCase();

  const link = document.createElement("a");
  link.href = url;

   if (["pdf", "html", "htm"].includes(fileExtension)) {
    // open in a new tab instead of downloading
    link.target = "_blank";
  } else {
    // force download for other file types
    link.setAttribute("download", "");
  }

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



    const handleShowModal = (title, url) => {
        setModalContent({ title, url });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    useEffect(() => {
        fetchJobRoles();
        fetchQualifications();
        GetCandidateDetails();
    }, [selectedCountry]);
    // const getExperienceText = (experience) => {
    //     if (!experience) return '';
    //     const lowerCaseExperience = experience.toLowerCase();
    //     return lowerCaseExperience.includes('years') ? experience : `${experience} years`;
    //   };
    const getExperienceText = (experience) => {
        if (!experience) return '';
        return experience?.toLowerCase().includes('years') ? experience : `${experience} years`;
      };
      
    const getJobRoleName = (id) => {
        const jobRole = jobRoles.find(role => role.jobRoleId == id);
        return jobRole ? jobRole.jobRole : "";
    };

    const getQualificationName = (id) => {
        const qualification = qualifications.find(q => q.qualificationID == id);
        return qualification ? qualification.courseName : "";
    };
  const renderAttachment = (url, file, html) => {
  if (html) {
    return (
      <div
        style={{ maxHeight: "500px", overflowY: "auto" }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }
 
  const name =
    (file && file.name?.toLowerCase()) ||
    (url && url.split("/").pop()?.toLowerCase()) ||
    "";
 
  if (!url) {
    return <div>File not found.</div>;
  }
 
  if (name.endsWith(".pdf")) {
    return (
      <iframe
        src={url}
        style={{ width: "100%", height: "500px", border: "none" }}
        title="PDF Preview"
      />
    );
  }
 
  // ✅ Image
 if (name.match(/\.(jpg|jpeg|png)$/)) {
    return (
      <div style={{ textAlign: "center" }}>
        <img
          src={url}
          alt="Image Preview"
          style={{
            maxWidth: "100%",
            maxHeight: "500px",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        />
        <div style={{ marginTop: "10px" }}>
          <a
            href={url}
            download={name.replace(/^[0-9a-fA-F-]+_/, "")} // clean name
            target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              color: "#007bff",
              fontWeight: "500",
            }}
          >
            ⬇️ Download Image
          </a>
        </div>
      </div>
    );
  }
 
  // ✅ HTML
  if (name.endsWith(".html") || name.endsWith(".htm")) {
    return (
      <iframe
        src={url}
        title="HTML Preview"
        style={{ width: "100%", height: "500px", border: "none" }}
      />
    );
  }
 
  // ✅ DOCX
  if (name.endsWith(".docx")) {
    if (url?.startsWith("https")) {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
          title="DOCX Preview"
          style={{ width: "100%", height: "500px", border: "none" }}
        />
      );
    } else {
      return (
        <div>
          <p>
            DOCX preview not supported for local files.{" "}
            <a href={url} target="_blank" rel="noreferrer">
              Download
            </a>
          </p>
        </div>
      );
    }
  }
 
  return (
    <div>
      <p>
        Preview not supported for this file type.{" "}
        <a href={url} target="_blank" rel="noreferrer">
          Download
        </a>
      </p>
    </div>
  );
};
const safeValue = (value) => 
  (value === null || value === undefined || value === "null" || value === "undefined") 
    ? "" 
    : value;

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    };
    return (
        <ConsultantLayout>
            {candidateDetails ? (
                <div className="container-fluid">
                    <div className='mb-3 mt-3' style={{ display: 'flex', alignItems: 'center' }}>
                        <Link to="/Employer/ViewMatchedInternalCandidates">
                            <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16 }} aria-hidden="true"></i>
                        </Link>
                        <h2 className="" style={{ color: "#00a7ac", marginLeft: '10px', marginBottom: '0', marginTop: '0' }}>Candidate Details</h2>
                    </div>
                    <hr />
                    <div className="card shadow-lg mt-5 p-5" style={{ border: "none" }}>
                        <div className="row mt-2">
                            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-fullName">Full Name</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.fullName}</p>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Email</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-envelope icons"></i> {candidateDetails.email}</p>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-mobileNumber">Mobile Number</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-phone icons"></i> {candidateDetails.mobileNumber}</p>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{ selectedCountry == 2 ? "PayRate" : " Current CTC" }</Tooltip>)}>
                                                  <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-dollar-sign" aria-hidden="true"></i> {safeValue(candidateDetails.payRate)}</p>
                                                </OverlayTrigger>
                                   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>   { selectedCountry == 2 ? "BillRate" : " Expected CTC" } </Tooltip>)}>
                                                   <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-money-bill" aria-hidden="true"></i>{safeValue(candidateDetails.billRate)}</p>
                                                 </OverlayTrigger>
                                                
                               {candidateDetails.gender !=null &&   candidateDetails.gender !== "null" && 
                               (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-gender">Gender</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-venus-mars icons"></i> {candidateDetails.gender}</p>
                                </OverlayTrigger>)}

                              {candidateDetails.address !=null &&   candidateDetails.address  !== "null" &&
                              ( <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-address">Address</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-map-marker icons"></i> {candidateDetails.address}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.dob  != null &&   candidateDetails.dob  !== "null" &&
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-dob">Date of Birth</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-birthday-cake icons"></i> {candidateDetails.dob}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.maritalStatus != null &&   candidateDetails.maritalStatus !== "null" &&  
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-maritalStatus">Marital Status</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-heart icons"></i> {capitalizeFirstLetter(candidateDetails.maritalStatus)}</p>
                                </OverlayTrigger>)}
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-experience">Experience</Tooltip>}>
        <p className="text-para"><i className="fa fa-briefcase icons"></i> {getExperienceText(candidateDetails.experience)}</p>
      </OverlayTrigger>
      {/* {candidateDetails.preferLocation != null &&   candidateDetails.preferLocation !== "null" &&  
                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-preferLocation">Country</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-map icons"></i>     {candidateDetails.preferLocation === "1" ? "India" : "United States"}</p>
                                </OverlayTrigger>} */}
                                {candidateDetails.technicalSkill != null &&   candidateDetails.technicalSkill !== "null" &&  
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-technicalSkill">Technical Skill</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {candidateDetails.technicalSkill}</p>
                                </OverlayTrigger>}
                                  {candidateDetails.highestEducation !=null &&   candidateDetails.highestEducation !== "null" && 
                               (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-gender">Highest Education</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-graduation-cap icons"></i> {candidateDetails.highestEducation}</p>
                                </OverlayTrigger>)}
                             
                                    {/* {candidateDetails.workAuthorizationandValidity !== null && candidateDetails.workAuthorizationandValidity!== "null" && 
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-technicalSkill">Work Authorization and Validity</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {candidateDetails.workAuthorizationandValidity}</p>
                                </OverlayTrigger>)} */}
                                {selectedCountry == 2 &&
  candidateDetails.workAuthorizationandValidity !== null &&
  candidateDetails.workAuthorizationandValidity !== "null" && (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id="tooltip-technicalSkill">
          Work Authorization and Validity
        </Tooltip>
      }
    >
      <p className="text-para">
        <i className="fa fa-cogs icons"></i> {candidateDetails.workAuthorizationandValidity}
      </p>
    </OverlayTrigger>
)}

  {candidateDetails.candidateType  !== null && candidateDetails.candidateType !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Candidate Type</Tooltip>}>
                                    <p className="text-para"><i className="fas fa-hourglass-half icons"></i> {safeValue(candidateDetails.candidateType)}</p>
                                </OverlayTrigger>)}

                                {candidateDetails.employerName !== null && candidateDetails.employerName!== "null" && 
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-technicalSkill">Employer Name</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {candidateDetails.employerName}</p>
                                </OverlayTrigger>}
                                
                                {candidateDetails.ssn !== null && candidateDetails.ssn !== "null" && 
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">SSN</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-building icons"></i> {candidateDetails.ssn}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.passportNo !== null && candidateDetails.passportNo !== "null" && 
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Passport Number</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-id-card icons"></i> {candidateDetails.passportNo}</p>
                                </OverlayTrigger>)}
      
                            </div>
                            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                           
                            {candidateDetails.tworefrencesfromrecentproject  !== null && candidateDetails.tworefrencesfromrecentproject !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Two Refrences from  Recent Project</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-building icons"></i> {candidateDetails.tworefrencesfromrecentproject}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.vendorName  !== null && candidateDetails.vendorName !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Client Name</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.vendorName}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.clientStatus  !== null && candidateDetails.clientStatus !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Candidate Status</Tooltip>}>
                                    <p className="text-para"><i className="fas fa-hourglass-half icons"></i> {safeValue(candidateDetails.clientStatus)}</p>
                                </OverlayTrigger>)}
                                {/* {candidateDetails.payRate  !== null && candidateDetails.payRate !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Pay Rate</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {candidateDetails.payRate}</p>
                                </OverlayTrigger>)} */}
                                {candidateDetails.createdBy  !== null && candidateDetails.createdBy !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">CreatedBy</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.createdBy}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.comments !== null && candidateDetails.comments !== "null" && (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Comments</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-building icons"></i>
                                     <span  dangerouslySetInnerHTML={{ __html: safeValue(candidateDetails.comments) }}></span></p>
                                </OverlayTrigger>)}
                                {candidateDetails.priority !== null && candidateDetails.priority !== "null" && (
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-workMode">Priority</Tooltip>}
  >
    <p className="text-para">
      <i className="fa fa-building icons"></i>    {candidateDetails.priority }
    </p>
  </OverlayTrigger>
)}
 {candidateDetails.workMode !== null && candidateDetails.workMode !== "null" &&
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Work Mode</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-building icons"></i> {candidateDetails.workMode}</p>
                                </OverlayTrigger>}
                                {candidateDetails.profileSummery !== null && candidateDetails.profileSummery !== "null" && ( 
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-profileSummery">Profile Summary</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-info-circle icons"></i> {candidateDetails.profileSummery}</p>
                                </OverlayTrigger>)}
                                {(candidateDetails.jobRole !== null && candidateDetails.jobRole !== 0 && candidateDetails.jobRole !== "null" ) && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobRole">Job Role</Tooltip>}>
        <p className="text-para"><i className="fa fa-briefcase icons"></i> {getJobRoleName(candidateDetails.jobRole)}</p>
    </OverlayTrigger>
)}

{(candidateDetails.qualificationID !== null && candidateDetails.qualificationID !== 0 && candidateDetails.qualificationID !== "null") && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-qualification">Qualification</Tooltip>}>
        <p className="text-para"><i className="fa fa-graduation-cap icons"></i> {getQualificationName(candidateDetails.qualificationID)}</p>
    </OverlayTrigger>
)}

{candidateDetails.linkedInUrl !== null && candidateDetails.linkedInUrl !== "null" && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-qualification">LinkedIn Url</Tooltip>}>
        <a 
            href={candidateDetails.linkedInUrl?.startsWith('http') ? candidateDetails.linkedInUrl : `https://${candidateDetails.linkedInUrl}`} 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <p className="text-para">
                <i className="fa fa-graduation-cap icons mr-1"></i>
                {candidateDetails.linkedInUrl}
            </p>
        </a>
    </OverlayTrigger>
)}

{(candidateDetails.customAssessmentLink !== null && candidateDetails.customAssessmentLink !== 0 && candidateDetails.customAssessmentLink !== "null") && (
     <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="tooltip-qualification">Custom Assessment Link</Tooltip>}
    >
      <a
        href={candidateDetails.customAssessmentLink}
        target="_blank"
        rel="noopener noreferrer"
        className="text-para d-flex align-items-center"
      >
        <i className="fa fa-link icons"></i>
        <span className="ml-2">Custom Assessment Link</span>
      </a>
    </OverlayTrigger>
)}
                                {(candidateDetails.resume || candidateDetails.visaCopy || candidateDetails.drivingLicence) && (
  <h2 className="" style={{ color: "#00a7ac", marginLeft: '10px', marginBottom: '0', marginTop: '0' }}>
    Attachments
  </h2>
)}
{candidateDetails.resume!==null  && candidateDetails.resume  !== "null"&& (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">Resume</Tooltip>}>
    <p className="text-para">
      <a 
        href="#" 
        style={{ fontSize: 18 }} 
        onClick={() => handleShowModal('Resume', candidateDetails.fileUrl)}
      >
        <i className="fa fa-file-alt icons"></i> View Resume
      </a>
      &nbsp;|&nbsp;
    <a
  href="#"
  style={{ fontSize: 18 }}
  onClick={(e) => {
    e.preventDefault();
    handleDownload(candidateDetails.fileUrl);
  }}
>
  <i className="fa fa-download icons"></i> Download Resume
</a>

    </p>
  </OverlayTrigger>
)}

{candidateDetails.visaCopy!==null  && candidateDetails.visaCopy  !== "null"&& (
      <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-visaCopy">Proof of Residence</Tooltip>}>
        <p className="text-para">
          <a 
            href="#" 
            style={{ fontSize: 18 }} 
            onClick={() => handleShowModal('Visa Copy', candidateDetails.visaCopyUrl)}
          >
            <i className="fa fa-id-card icons"></i>View Work Authorization 
          </a>
          &nbsp;|&nbsp;
          <a 
            href={candidateDetails.visaCopyUrl} 
            style={{ fontSize: 18 }} 
            onClick={(e) => {
    e.preventDefault();
    handleDownload(candidateDetails.visaCopyUrl);
  }}
            target="_blank"
          >
            <i className="fa fa-download icons"></i>Download Work Authorization
          </a>
        </p>
      </OverlayTrigger>)}
      {candidateDetails.drivingLicence!==null  && candidateDetails.drivingLicence  !== "null"&& (

      <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-drivingLicence">Government Issued ID</Tooltip>}>
        <p className="text-para">
          <a 
            href="#" 
            style={{ fontSize: 18 }} 
           
            onClick={() => handleShowModal('Driving Licence', candidateDetails.drivingLicenceUrl)}
          >
            <i className="fa fa-car icons"></i> View Government Issued ID
          </a>
          &nbsp;|&nbsp;
          <a 
            href={candidateDetails.drivingLicenceUrl} 
            style={{ fontSize: 18 }} 
                      onClick={(e) => {
    e.preventDefault();
    handleDownload(candidateDetails.drivingLicenceUrl);
  }}
            target="_blank"
          >
            <i className="fa fa-download icons"></i> Download Government Issued ID
          </a>
        </p>
      </OverlayTrigger>)}
         {candidateDetails.rtR_PDF!==null  && candidateDetails.rtR_PDF  !== "null"&& (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">RTR PDF</Tooltip>}>
    <p className="text-para">
      <a 
        href="#" 
        style={{ fontSize: 18 }} 
        onClick={() => handleShowModal('RTR PDF', candidateDetails.rtR_PDFDoc
)}
      >
        <i className="fa fa-file-alt icons"></i> View RTR_PDF
      </a>
      &nbsp;|&nbsp;
      <a 
        href={candidateDetails.rtR_PDFDoc
} 
        style={{ fontSize: 18 }} 
        onClick={(e) => {
    e.preventDefault();
    handleDownload(candidateDetails.rtR_PDFDoc);
  }}
        target="_blank"
      >
        <i className="fa fa-download icons"></i> Download RTR_PDF
      </a>
    </p>
  </OverlayTrigger>
)} 
      
      {candidateDetails.i94!==null  && candidateDetails.i94  !== "null"&& (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">I-94</Tooltip>}>
    <p className="text-para">
      <a 
        href="#" 
        style={{ fontSize: 18 }} 
        onClick={() => handleShowModal('I-94', candidateDetails.i94File)}
      >
        <i className="fa fa-file-alt icons"></i> View I-94
      </a>
      &nbsp;|&nbsp;
      <a 
        href={candidateDetails.i94File} 
        style={{ fontSize: 18 }} 
            onClick={(e) => {
    e.preventDefault();
    handleDownload(candidateDetails.i94File);
  }}
        target="_blank"
      >
        <i className="fa fa-download icons"></i> Download I-94
      </a>
    </p>
  </OverlayTrigger>
)}
{candidateDetails.passport !==null  && candidateDetails.passport  !== "null" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">Passport</Tooltip>}>
    <p className="text-para">
      <a 
        href="#" 
        style={{ fontSize: 18 }} 
        onClick={() => handleShowModal('Passport', candidateDetails.passportURL)}
      >
        <i className="fa fa-file-alt icons"></i> View Passport
      </a>
      &nbsp;|&nbsp;
      <a 
        href={candidateDetails.passportURL} 
        style={{ fontSize: 18 }} 
            onClick={(e) => {
    e.preventDefault();
    handleDownload(candidateDetails.passportURL);
  }}
        target="_blank"
      >
        <i className="fa fa-download icons"></i> Download Passport
      </a>
    </p>
  </OverlayTrigger>
)}
{candidateDetails.resume_Insights_Pdf !==null  && candidateDetails.resume_Insights_Pdf  !== "null" && (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">Resume_Insights_Pdf</Tooltip>}>
    <p className="text-para">
      <a 
        href="#" 
        style={{ fontSize: 18 }} 
        onClick={() => handleShowModal('resume_Insights_Pdf', candidateDetails.resume_Insights_Pdfdoc)}
      >
        <i className="fa fa-file-alt icons"></i> View Resume_Insights_Pdf
      </a>
      &nbsp;|&nbsp;
      <a 
        href={candidateDetails.resume_Insights_Pdfdoc} 
        style={{ fontSize: 18 }} 
             onClick={(e) => {
    e.preventDefault();
    handleDownload(candidateDetails.resume_Insights_Pdfdoc);
  }}
        target="_blank"
      >
        <i className="fa fa-download icons"></i> Download Resume_Insights_Pdf
      </a>
    </p>
  </OverlayTrigger>
)}
{candidateDetails.others!==null  && candidateDetails.others  !== "null"&& (
      <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-visaCopy">Others Doc</Tooltip>}>
        <p className="text-para">
          <a 
            href="#" 
            style={{ fontSize: 18 }} 
            onClick={() => handleShowModal('Others', candidateDetails.othersDoc)}
          >
            <i className="fa fa-id-card icons"></i> View Others Document
          </a>
          &nbsp;|&nbsp;
          <a 
            href={candidateDetails.othersDoc} 
            style={{ fontSize: 18 }} 
                  onClick={(e) => {
    e.preventDefault();
    handleDownload(candidateDetails.othersDoc);
  }}
            target="_blank"
          >
            <i className="fa fa-download icons"></i> Download Others Document
          </a>
        </p>
      </OverlayTrigger>)}
                                <Modal show={showModal} onHide={handleCloseModal} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>{modalContent.title}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {renderAttachment(modalContent.url)}
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <center><LoadingSpinner /></center>
            )}
        </ConsultantLayout>
    );
};

export default ViewInternalCandidateDetailsByCandidateGUid;





